import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentCategory } from 'app/models/dto/document-category.model';
import _ from 'lodash';

@Component({
  selector: 'app-document-upload-dialog',
  templateUrl: './document-upload-dialog.component.html',
  styleUrls: ['./document-upload-dialog.component.scss']
})
export class DocumentUploadDialogComponent implements OnInit {

    @Output() documentsEmitter = new EventEmitter<any[]>();

    documentsToCategorize: any[];
    disableSaveButton = true;
    title: string;
    saveButton: string;

    constructor(
        public dialogRef: MatDialogRef<DocumentUploadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            documents: any[];
            categories: DocumentCategory[];
        }
    ) { }

    ngOnInit() {
        this.documentsToCategorize = this.data.documents;
        this.setTitle();
    }

    setTitle() {
        if (this.data.documents.length > 1) {
            this.title = 'Select label for documents';
            this.saveButton = 'Add Labels';
        } else {
            this.title = 'Select label for document';
            this.saveButton = 'Add Label';
        }
    }

    getCategory(document): void | null | string {
        if (this.data.categories) {
            return document.category ? null : 'Choose Type';
        }
    }

    updateDocument(index, category): void {
        this.documentsToCategorize[index].category = category;
        this.disableSaveButton = _.every(this.documentsToCategorize, 'category') ? false : true;
    }

    save() {
        this.dialogRef.close(this.documentsToCategorize);
    }

    cancel() {
        this.dialogRef.close();
    }
}
